<template>
  <div ref="wrapper" class="w-full h-full  overflow-y-auto">
    <div v-if="dataLoaded && boxWidth" class="w-full h-full flex-col p-4 md:px-8 md:pt-6">
      <IconField class="w-full">
        <InputText v-model="searchQuery" placeholder="חיפוש"/>
        <InputIcon class="pi pi-search"/>
      </IconField>

      <div
        v-if="mainVideo"
        class="w-full bg-gray-200 p-4 justify-center items-center rounded-lg mt-2 overflow-hidden flex flex-col">
        <span class="mb-4 font-medium">מה זה טיימאיט?</span>
        <iframe
          :width="370"
          :height="208"
          class="rounded-lg"
          :src="mainVideo.videoLink+'?controls=1&rel=0&autoplay=0&loop=0'"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen></iframe>

      </div>

      <div
        v-if="videosToShow.length > 0"
        class="flex flex-row flex-wrap overflow-hidden gap-2 justify-between mt-2 pb-4">
        <div
          v-for="video of videosToShow"
          :key="video.vId"
          class="flex-col justify-center items-center flex"
          :style="{width: boxWidth + 'px'}">
          <div
            :ref="(el)=> {youtubeRefsWrappers[video.vId] = el;}"
            :style="{width: boxWidth + 'px', height: boxWidth + 'px'}"
            class="rounded-lg overflow-hidden"
            @click="clickedVideo(video.vId)"
          >
            <div class="pointer-events-none">
              <YoutubeVue3
                :ref="(el)=> {youtubeRefs[video.vId] = el;}"
                class="pointer-events-none"
                :videoid="video.vId"
                :loop="1"
                :controls="0"
                :autoplay="0"
                :width="boxWidth"
                :height="boxWidth"/>
            </div>
          </div>
          <span class="py-2 text-sm font-medium">{{ video.title }}</span>
        </div>
      </div>
      <div v-else class="flex flex-col justify-center items-center w-full h-full">
        <span class="font-medium mb-4">לא הצלחנו למצוא סרטונים מתאימים</span>
        <span>אבל לא נורא, בשביל זה אנחנו פה</span>
        <div
          class="py-2 px-4 border border-solid m-2 bg-[#25D366] text-white rounded-3xl border-green-500 flex gap-2 justify-center items-center "
          @click="sendWhatsApp('972559299380', 'היי, אשמח לקבל עוד פרטים לגבי הפעלת שירות תשלומים בעסק שלי')">
          <i class="pi pi-whatsapp"/>
          <span>שלחו לנו הודעה</span>
        </div>
      </div>
    </div>
    <retry-loader
      v-else
      :isErrorState="isErrorState"
      @retry-function="fetchData"
    />
  </div>
</template>

<script lang="ts" setup>
interface IHelpCenterExtended extends IHelpCenter {
  vId: string;
  allRelatedText: string;
}

import { ComponentPublicInstance, onMounted, reactive, Ref, ref, watch } from 'vue';
import {YoutubeVue3} from 'youtube-vue3'
import {search} from 'fast-fuzzy';
import {sendWhatsApp} from "@torim-app/utils";

import {HelpCenterTypes, IHelpCenter} from "@torim-app/types";
import {useAdminStore} from '@app/stores';
import {SharedApi} from "@app/api/admin";
import {AdminRouteNames} from '@app/router/route-names';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import { trackEvent } from '@app/composables/posthog';

const adminStore = useAdminStore();

const dataLoaded = ref(false);
const isErrorState = ref(false);
const videos = ref<Array<IHelpCenterExtended>>([]);
const videosToShow = ref<Array<IHelpCenterExtended>>([]);
const mainVideo = ref<IHelpCenterExtended>();
const searchQuery = ref<string>()
const wrapper = ref<HTMLDivElement>();
const boxWidth = ref<number>(0);
const youtubeRefs = reactive<Record<string, any>>({})
const youtubeRefsWrappers = reactive<Record<string, Element | ComponentPublicInstance | null>>({})
const selectedVideo = ref<string>();

const extractId = (url: string) => {
  return url.split('/')?.pop()?.replace('watch?v=', '');
}

const clickedVideo = (vId: string) => {
  trackEvent('help_video_clicked');
  const wrapperElement = (youtubeRefsWrappers[vId] as unknown as HTMLDivElement);
  if (selectedVideo.value === vId) {
    wrapperElement.style.removeProperty("position");
    wrapperElement.style["width"] = boxWidth.value + 'px';
    wrapperElement.style["height"] = boxWidth.value + 'px';
    wrapperElement.style.removeProperty("top");
    wrapperElement.style.removeProperty("z-index");
    wrapperElement.style.removeProperty("left");
    wrapperElement.style.removeProperty("background");
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    youtubeRefs[vId]?.player.setSize(boxWidth.value, boxWidth.value);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    youtubeRefs[vId]?.player.stopVideo();
    selectedVideo.value = undefined;
  } else {
    wrapperElement.style["position"] = 'absolute';
    wrapperElement.style["width"] = '100vw';
    wrapperElement.style["height"] = '100vh';
    wrapperElement.style["top"] = '0';
    wrapperElement.style["left"] = '0';
    wrapperElement.style["zIndex"] = '99';
    wrapperElement.style["background"] = 'white';
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    youtubeRefs[vId]?.player.setSize(wrapperElement.offsetWidth, wrapperElement.scrollHeight);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    youtubeRefs[vId]?.player.playVideo();
    selectedVideo.value = vId;
  }
}
const fetchData = () => {
  isErrorState.value = false;

  SharedApi.getAllHelpCenterEntities()
    .then(helpCenterEntities => {
      dataLoaded.value = true;
      console.log('dataLoaded', dataLoaded.value)

      videos.value.splice(0);
      videos.value.push(...helpCenterEntities.filter(hce => hce.type === HelpCenterTypes.Video && hce.active).map<IHelpCenterExtended>(x => ({
        ...x,
        vId: extractId(x.videoLink!)!,
        allRelatedText: [x.title, x.description, ...x.tags].join(' ')
      })));
      videosToShow.value = [...videos.value].filter(hce => !hce.mainVideo);
      mainVideo.value = videos.value.find(x => x.mainVideo);
      console.log(mainVideo.value)
    })
    .catch((err) => {
      console.error(err);
      isErrorState.value = true;
      console.log('isErrorState', isErrorState.value)
    });
};

onMounted(() => {
  trackEvent('help_center_viewed');
  adminStore.setPage(AdminRouteNames.HelpCenter);
  fetchData();

  boxWidth.value = wrapper.value?.offsetWidth ? wrapper.value?.offsetWidth / 2.25 : 0;
})

watch(searchQuery, () => {
  if (searchQuery.value) {
    trackEvent('help_center_searched', { query: searchQuery.value });
    const searchRes = search(searchQuery.value, videos.value.filter(hce => !hce.mainVideo), {
      keySelector: (obj) => obj.allRelatedText,
      returnMatchData: true
    },);
    videosToShow.value.splice(0)
    videosToShow.value.push(...searchRes.map(sr => sr.item))
  } else {
    videosToShow.value.splice(0)
    videosToShow.value.push(...videos.value);
  }
})

</script>

<style lang="scss" scoped>
@use '../../../assets/css/vars' as *;

.profile {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: white;
  width: 100%;
  padding: 0.5rem 1rem;
  min-height: 100%;
  overflow-y: auto;

  .profile {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .texts {
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-direction: column;
      margin-top: 0.5rem;

      .title {
        font-size: 1.75rem;
        line-height: 2.5rem;
        font-weight: 700;
        text-align: center;
      }
    }
  }

  .actions, .tags {
    margin-top: 1.5rem;
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    align-items: center;

    .p-button {
      background: black;
      border: none;
    }
  }

  .tags {
    justify-content: center;
    gap: 1rem;
    flex-wrap: wrap;
  }

  .timeline-header {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 100%;

    .p-button {
      background: transparent;
      border: none;
      color: black;

      &:hover {
        color: grey;
      }
    }
  }

  .subtitle-bold {
    font-size: 1.25rem;
    text-align: start;
    width: 100%;
    margin: 2rem 0 1.5rem 0;
  }

  .customized-timeline {
    width: 100%;
    display: flex;
    align-items: flex-start;

    .custom-marker {
      border: 1px solid #b7b7b7;
      padding: 0.85rem;
      border-radius: 50%;
      aspect-ratio: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      color: $lead-color;
    }

    .custom-content {
      padding: 0 0.5rem;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      width: 100%;
      margin-bottom: 1.5rem;

      .future-appointment, .cancelled-appointment {
        padding: 0.25rem;
        border-radius: 0.25rem;
        background: $third-color;
        color: white;
        font-weight: bold;
        font-size: 0.75rem;
        margin-bottom: 0.25rem;
      }

      .cancelled-appointment {
        background: grey;
      }

      .date {
        font-size: 0.85rem;
        color: grey;
      }

      .event-details {
        border-radius: 0.5rem;
        margin: 0.6rem 0;
        padding: 0.5rem;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        background: $gray-bg;
        flex-direction: row;
        text-align: start;
      }

      .event-notes {
        text-align: start;
        font-size: 0.85rem;

        strong {
          font-size: 0.9rem;
          color: grey;
        }
      }

      .add-note {
        .p-button {
          padding: 0 !important;
          margin-right: 0.3rem;
          color: black;

          .p-button-label {
            font-weight: 400 !important;
          }
        }
      }
    }
  }
}
</style>
